import { render, staticRenderFns } from "./IdentificationMainPanel.vue?vue&type=template&id=9c740392&scoped=true"
import script from "./IdentificationMainPanel.vue?vue&type=script&lang=js"
export * from "./IdentificationMainPanel.vue?vue&type=script&lang=js"
import style0 from "./IdentificationMainPanel.vue?vue&type=style&index=0&id=9c740392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c740392",
  null
  
)

export default component.exports